// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";
import { forwardRef } from "react";

import {
  Button,
  type ButtonProps,
} from "metabase/common/components/Button/Button";
import { breakpointMaxSmall } from "metabase/styled-components/theme";

const NewButtonBase = forwardRef<HTMLButtonElement, ButtonProps>(
  (props, ref) => (
    <Button {...props} ref={ref} iconSize={props.iconSize ?? 16} />
  ),
);
NewButtonBase.displayName = "NewButtonBase";

export const NewButton = styled(NewButtonBase)`
  display: flex;
  align-items: center;
  height: 2.25rem;
  padding: 0.5rem;
  background-color: var(--mb-color-brand-hover);
  border-color: var(--mb-color-brand-hover);

  &:hover {
    background-color: var(--mb-color-metabase-brand-hover);
    border-color: var(--mb-color-metabase-brand-hover);
  }

  &:focus-visible {
    outline: 2px solid var(--mb-color-text-white);
    outline-offset: 2px;
  }

  ${Button.TextContainer} {
    margin-left: 0;
  }

  ${breakpointMaxSmall} {
    display: none;
  }

  @media (forced-colors: active) {
    border: 1px solid ButtonText;

    &:focus-visible {
      outline: 2px solid Highlight;
    }
  }
`;

export const NewButtonText = styled.span`
  display: inline;
  margin-left: 0.5rem;
  white-space: nowrap;
  color: var(--mb-color-text-white);
`;
